/************************* Helpers *************************/

let drawerOverlayLoaded = false;

const createDrawerOverlay = () => {
  const overlay = document.createElement('div');
  overlay.classList.add('g-drawer-overlay')
  document.body.append(overlay)

  drawerOverlayLoaded = true;
}

let modalOverlayLoaded = false;

const createModalOverlay = () => {
  const overlay = document.createElement('div');
  overlay.classList.add('g-modal-overlay')
  document.body.append(overlay)

  modalOverlayLoaded = true;
}


/************************* Create2Stay - PDP - Hover text *************************/



class Create2stay extends HTMLElement {

  constructor() {
    super();

    this.triggers = this.querySelectorAll('[data-trigger]');
    this.activeTrigger = this.querySelector('[data-trigger].active');
    this.activeContent = this.querySelector('[data-content].active');

    this.triggers.forEach((trigger, i) => {

      trigger.addEventListener('mouseover', () => {
        if (this.activeTrigger !== trigger) {
        }
        this.RemoveCurrentActive();
        this.querySelector(`[data-content="${ i + 1 }"]`).classList.add('active');
      });

      trigger.addEventListener('mouseleave', () => {
        this.RemoveCurrentActive();
        this.activeContent.classList.add('active');
      });
    });
  }

  RemoveCurrentActive = () => {
    const activeCondition = this.querySelector('.create2stay_descriptions .active');
    if (!activeCondition) return
    activeCondition.classList.remove('active');
  }


}

customElements.define('create-2-stay', Create2stay);

/************************* Cart drawer  *************************/



const removeLiveItem = (elem) => {
  elem.addEventListener('click', (e) => {
    var target = e.target;

    if (target.hasAttribute('data-clear')) {
      e.preventDefault();

      const cartItem = target.closest('.cart__item');
      if (!cartItem) return

      const qtyInput = cartItem.querySelector('.js-qty__wrapper .js-qty__num');

      if (!qtyInput) return

      qtyInput.value = 0;
      qtyInput.dispatchEvent(new Event('change'));
    }
  });
}

(async function() {
  const cartDrawer = document.getElementById('CartDrawer');
  if (!cartDrawer) return
  removeLiveItem(cartDrawer)
})();


/************************* linked products - Title hover  *************************/

const linkedProductCurrentColorName = document.querySelector('.linked-products [data-linked-product-current-color-name], .vr-label [data-linked-product-current-color-name]');
const linkedProductsColorName = document.querySelectorAll('.linked-products [data-linked-product-color-name], .vr-linked-product[data-linked-product-color-name]');

if (linkedProductCurrentColorName && linkedProductsColorName.length > 1) {
  const currentColorNameText = linkedProductCurrentColorName.hasAttribute('data-linked-product-current-color-name') ? linkedProductCurrentColorName.getAttribute('data-linked-product-current-color-name') : ''

  const changeColorName = (text) => {
    linkedProductCurrentColorName.innerText = text
  }

  linkedProductsColorName.forEach(colorName => {
    const colorNameText = colorName.hasAttribute('data-linked-product-color-name') ? colorName.getAttribute('data-linked-product-color-name') : ''

    colorName.addEventListener('mouseover', () => {
      changeColorName(colorNameText)
    });
    colorName.addEventListener('mouseout', () => {
      changeColorName(currentColorNameText)
    });
  });
}

/************************* Cart count  *************************/

class CartCount extends HTMLElement {

  constructor() {
    super();
    document.addEventListener('cart:updated', async (event) => {
      if (event.detail?.cart?.item_count) {
        this.UpdateNumber(event.detail.cart.item_count);
      }
    })

    document.addEventListener('ajaxProduct:added', async () => {
      var url = ''.concat('/cart.js', '?t=').concat(Date.now());
      const cartData = await fetch(url, { priority: "low", credentials: 'same-origin', method: 'GET' }).then(response => response).then(data => data.json());
      if (cartData?.item_count) {
        this.UpdateNumber(cartData.item_count);
      }
    })
  }

  UpdateNumber(number) {
    this.innerText = number;
  }

}

customElements.define('cart-count', CartCount);



/************************* Product card - Sizes *************************/



class ProductSizes extends HTMLElement {

  constructor() {
    super();

    this.dom = {
      triggers: this.querySelectorAll('input'),
      submit: this.querySelector('button')
    }

    this.settings = {
      currentId: null
    }

    if (!this.dom.triggers && !this.dom.submit) return
    this.dom.triggers.forEach((trigger, i) => {
      this.TriggerEvents(trigger);
    });

    this.SubmitEvents();
  }

  async TriggerEvents(trigger) {
    trigger.addEventListener('change', () => {
      if (trigger.checked === true) {
        this.settings.currentId = trigger.value
        if (this.settings.currentId) {
          this.dom.submit.removeAttribute('disabled');
        } else {
          this.dom.submit.setAttribute('disabled', '');
        }
      }
    });
  }

  async SubmitEvents() {
    this.dom.submit.addEventListener('click', this.Submit.bind(this))
  }

  async Submit() {

    if (!this.settings.currentId) return

    this.dom.submit.classList.add('btn--loading');

    this.AddToCart({ variantId: this.settings.currentId, quantity: 1 });

  }

  AddToCart({ variantId, quantity }) {
    const formData = { items: [{ 'id': variantId, 'quantity': quantity }] };

    fetch('/cart/add.js', {
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      },
      body: JSON.stringify(formData)
    })
      .then(response => {
        return response.json().then(data => {
          if (response.ok) {
            this.dom.submit.classList.remove('btn--loading');

            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              bubbles: true,
              detail: {
                variant: variantId,
                quantity: quantity
              }
            }));

          } else {
            this.dom.submit.classList.remove('btn--loading');
            this.ErrorHandler({ errorData: data });
          }
        })

      }).catch((error) => {
        console.error('Error:', error);
      });
  }

  ErrorHandler({ errorData }) {

    switch (errorData.status) {
      case 422: //Not enough inventory  
        this.ErrorAlertMessage({ errorData });
        break;
    }
  }

  ErrorAlertMessage({ errorData }) {
    setTimeout(() => {
      alert(errorData.description)
    }, 400);
  }
}
customElements.define('product-sizes', ProductSizes);


const setFooterCompensatorHeight = () => {
  const pdpAddGroup = document.querySelector('.pdp-add-group');
  if (window.matchMedia('(max-width: 768px)').matches && pdpAddGroup) {
    const footerCompensator = pdpAddGroup.offsetHeight;
    // set the value of --footer-compensator CSS variable to footerCompensator value
    document.documentElement.style.setProperty('--footer-compensator', `${footerCompensator}px`);
  }
  else{
    document.documentElement.style.setProperty('--footer-compensator', `0px`);
  }
} 

// call the function on init and resize
window.addEventListener('DOMContentLoaded', setFooterCompensatorHeight);
let timeoutId;
window.addEventListener('resize', () => {
  clearTimeout(timeoutId);
  timeoutId = setTimeout(setFooterCompensatorHeight, 300);
});
